module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e162"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e164"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c7_r1#d12e304",
      "id": "d12e165"
    }
  }, [_vm._v("one")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e167"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c8_r1#d12e463",
      "id": "d12e168"
    }
  }, [_vm._v("two")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e170"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c9_r1#d12e672",
      "id": "d12e171"
    }
  }, [_vm._v("three")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e173"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c10_r1#d12e835",
      "id": "d12e174"
    }
  }, [_vm._v("four")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e176"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c11_r1#d12e1025",
      "id": "d12e177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("five")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e179"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c12_r1#d12e1180",
      "id": "d12e180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("six")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e182"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c13_r1#d12e1248",
      "id": "d12e183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seven")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e185"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c14_r1#d12e1540",
      "id": "d12e186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eight")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e188"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c15_r1#d12e1659",
      "id": "d12e189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("nine")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e191"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c16_r1#d12e1943",
      "id": "d12e192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ten")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e195"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c17_r1#d12e2159",
      "id": "d12e196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e198"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c18_r1#d12e2483",
      "id": "d12e199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e201"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c19_r1#d12e2576",
      "id": "d12e202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e204"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c20_r1#d12e2855",
      "id": "d12e205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e207"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c21_r1#d12e2977",
      "id": "d12e208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e210"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c22_r1#d12e3139",
      "id": "d12e211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e213"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c23_r1#d12e3340",
      "id": "d12e214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e216"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c24_r1#d12e3425",
      "id": "d12e217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e219"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c25_r1#d12e3730",
      "id": "d12e220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e222"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c26_r1#d12e3906",
      "id": "d12e223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e225"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c27_r1#d12e4027",
      "id": "d12e226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-one")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e229"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c28_r1#d12e4101",
      "id": "d12e230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-two")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e232"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c29_r1#d12e4248",
      "id": "d12e233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-three")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e235"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c30_r1#d12e4547",
      "id": "d12e236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-four")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e238"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c31_r1#d12e4810",
      "id": "d12e239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-five")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e241"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c32_r1#d12e4982",
      "id": "d12e242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-six")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e244"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c33_r1#d12e5091",
      "id": "d12e245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-seven")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e247"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c34_r1#d12e5412",
      "id": "d12e248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-eight")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e250"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c35_r1#d12e5466",
      "id": "d12e251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twenty-nine")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e253"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c36_r1#d12e5601",
      "id": "d12e254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e256"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c37_r1#d12e5778",
      "id": "d12e257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-one")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e259"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c38_r1#d12e5959",
      "id": "d12e260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-two")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e263"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c39_r1#d12e6159",
      "id": "d12e264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-three")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e266"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c40_r1#d12e6294",
      "id": "d12e267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-four")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e269"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c41_r1#d12e6457",
      "id": "d12e270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-five")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e272"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c42_r1#d12e6527",
      "id": "d12e273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-six")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e275"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c43_r1#d12e6745",
      "id": "d12e276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-seven")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e278"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c44_r1#d12e6941",
      "id": "d12e279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-eight")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e281"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c45_r1#d12e7038",
      "id": "d12e282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirty-nine")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e284"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c46_r1#d12e7319",
      "id": "d12e285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("forty")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e287"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c47_r1#d12e7511",
      "id": "d12e288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("forty-one")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e290"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c48_r1#d12e7790",
      "id": "d12e291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("forty-two")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e293"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c50_r1#d12e7961",
      "id": "d12e294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e297"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c51_r1#d12e7996",
      "id": "d12e298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reading group guide")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e300"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c52_r1#d12e8028",
      "id": "d12e301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A note from the author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d73e272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hunt_9781595542595_epub_c6.1_r1.vue
// module id = 72
// module chunks = 0